import { useEffect } from "react";

export const usePasteHandler = (handleImageUpload: (file: File) => void) => {
  useEffect(() => {
    const handlePaste = (event: ClipboardEvent) => {
      const items = event.clipboardData?.items;
      if (!items) return;

      for (const item of items) {
        if (item.kind === "file") {
          const pastedFile = item.getAsFile();
          if (pastedFile && pastedFile.type.startsWith("image/")) {
            handleImageUpload(pastedFile);
            break;
          }
        }
      }
    };

    window.addEventListener("paste", handlePaste as EventListener);
    return () => {
        window.removeEventListener("paste", handlePaste as EventListener);
    };
  }, [handleImageUpload]);
};